import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=16281179&scoped=true&"
import script from "./appeal.vue?vue&type=script&lang=js&"
export * from "./appeal.vue?vue&type=script&lang=js&"
import style0 from "./appeal.vue?vue&type=style&index=0&id=16281179&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16281179",
  null
  
)

export default component.exports